import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addSupplier } from "../../../store/actions"
import { useEffect } from "react"

const AddSupplier = props => {
  const dispatch = useDispatch()
  document.title = "Add Supplier"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      supplier_name: "",
    },
    validationSchema: Yup.object({
      supplier_name: Yup.string().required("Please Enter Supplier"),
    }),
    onSubmit: values => {
      dispatch(addSupplier(values, props.history))
    },
  })

  const supplier = useSelector(state => state.supplierName)
  const { error } = useSelector(state => ({
    error: state.supplierName.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Supplier" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="supplier_name_form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="supplier_name">
                            Supplier Name
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="supplier_name"
                            autoComplete="off"
                            className={
                              validation.touched.colli_name &&
                              validation.errors.colli_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="supplier_name"
                            placeholder="Enter Supplier Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.supplier_name || ""}
                          />
                          {validation.touched.supplier_name &&
                          validation.errors.supplier_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.supplier_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {supplier && supplier.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddSupplier
